import { AssignHomeworkPage } from "@/pages/teacher/AssignHomeworkPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/assign/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AssignHomeworkPage />;
}
